import { Routes } from '@angular/router';

export const DESKTOP_REPLENISHMENT_REQUESTS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./replenishment-request-list/replenishment-request-list.component').then(
        c => c.DesktopReplenishmentRequestsListComponent,
      ),
  },
];
